import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { deleteQuoteRequestLine } from "#modules/quoteRequestLines/infra/deleteQuoteRequestLine.api";
import { quoteRequestLinesQuery } from "#modules/quoteRequestLines/quoteRequestLinesQuery";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";

export const useDeleteQuoteRequestLine = (options?: { onSuccess?: () => void }) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: deleteQuoteRequestLine,
    onSuccess: (quoteRequestLine) => {
      if (quoteRequestLine) {
        void queryClient.invalidateQueries(quoteRequestQuery(quoteRequestLine.quoteRequestId));
        void queryClient.invalidateQueries(quoteRequestLinesQuery());
        showSuccessToast({ title: "Pièce supprimée" });
      }
      options?.onSuccess?.();
    },
    onError: (err) => {
      showErrorToast({
        title: "Une erreur est survenue lors de la suppression de la pièce",
      });
      errorHandler(err);
    },
  });

  return { deleteQuoteRequestLine: mutate, ...rest };
};
